export const visit = (vm, at) => {
at({ "af": { "sanitizedEmail": { "imageError": "Hierdie beeld is te groot om te wys.", "expandEmailButtonText": "Vou uit", "collapseEmailButtonText": "Vou in", "hideEmailRepliesButtonText": "Versteek geknipte inhoud", "showEmailRepliesButtonText": "Bekyk geknipte inhoud" } } });
};